import { IObraState } from './interfaces/IObraState';
import { ObraActionUnion, ObraActionKeys } from './Obra.actions';
import { IUsersConstructionSiteResponse } from 'Data/interfaces/User/IUsersConstructionSiteResponse';

const initialState: IObraState = {
  Users: {} as IUsersConstructionSiteResponse,
  isLoading: false,
  constructionSiteIds: [],
  responseTime: undefined,
  isLoadingGetUsersConstruction: false,
  usersForLimitInvited: [],
  isCollapsed: false,
  archivesPath: undefined,
  plotagensPath: undefined,
  clearConstructionSiteSearch: false,
  editLoading: false,
  newEditLoading: false,
};

const obraReducer = (state = initialState, action: ObraActionUnion): IObraState => {
  switch (action.type) {
    case ObraActionKeys.GET_DISCIPLINES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ObraActionKeys.GET_DISCIPLINES_SUCCESS:
      const Disciplines = action.payload.filter((discipline: any) => {
        return discipline.Name !== 'Personalizado';
      });
      return {
        ...state,
        Disciplines,
        isLoading: false,
      };
    case ObraActionKeys.GET_DISCIPLINES_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case ObraActionKeys.GET_USERS_CONSTRUCTION_SITE_REQUEST:
      return {
        ...state,
        isLoadingGetUsersConstruction: true,
      };
    case ObraActionKeys.GET_USERS_CONSTRUCTION_SITE_SUCCESS:
      return {
        ...state,
        Users: action.payload,
        isLoadingGetUsersConstruction: false,
      };
    case ObraActionKeys.GET_USERS_CONSTRUCTION_SITE_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoadingGetUsersConstruction: false,
      };

    case ObraActionKeys.BIND_USERS_CONSTRUCTION_SITE_REQUEST:
      return {
        ...state,
        isLoadingGetUsersConstruction: true,
      };
    case ObraActionKeys.BIND_USERS_CONSTRUCTION_SITE_SUCCESS:
      return {
        ...state,
        isLoadingGetUsersConstruction: false,
      };
    case ObraActionKeys.BIND_USERS_CONSTRUCTION_SITE_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoadingGetUsersConstruction: false,
      };

    case ObraActionKeys.LIST_CONSTRUCTION_SITE_ACCOUNTS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ObraActionKeys.LIST_CONSTRUCTION_SITE_ACCOUNTS_SUCCESS:
      return {
        ...state,
        AccountsInfo: action.payload,
        isLoading: false,
      };
    case ObraActionKeys.LIST_CONSTRUCTION_SITE_ACCOUNTS_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case ObraActionKeys.LIST_CONSTRUCTION_SITES_STORAGE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ObraActionKeys.LIST_CONSTRUCTION_SITES_STORAGE_SUCCESS:
      return {
        ...state,
        StorageList: action.payload,
        isLoading: false,
      };
    case ObraActionKeys.LIST_CONSTRUCTION_SITES_STORAGE_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case ObraActionKeys.GET_ALL_CONSTRUCTIONS_SITES_REQUEST:
      return {
        ...state,
        isLoading: false,
      };
    case ObraActionKeys.GET_ALL_CONSTRUCTIONS_SITES_SUCCESS:
      const ids = action.payload.map((constructionSite) => constructionSite.ConstructionSiteId);

      return {
        ...state,
        isLoading: false,
        constructionSiteIds: ids,
      };
    case ObraActionKeys.GET_ALL_CONSTRUCTIONS_SITES_FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case ObraActionKeys.CLEAR_ALL_CONSTRUCTIONS_SITES:
      return {
        ...state,
        isLoading: false,
        constructionSiteIds: [],
      };

    case ObraActionKeys.OBRA_USERS_LIMIT_INVITED:
      return {
        ...state,
        usersForLimitInvited: action.payload,
      };

    case ObraActionKeys.TOGGLE_COLLAPSED:
      return {
        ...state,
        isCollapsed: action.payload,
      };

    case ObraActionKeys.STORE_ARCHIVES_PATH:
      return {
        ...state,
        archivesPath: action.payload,
      };
    case ObraActionKeys.STORE_PLOTAGENS_PATH:
      return {
        ...state,
        plotagensPath: action.payload,
      };

    case ObraActionKeys.CLEAR_CONSTRUCTION_SITE_SEARCH:
      return {
        ...state,
        clearConstructionSiteSearch: action.payload,
      };

    default:
      return state;

  };
}

export default obraReducer;
